export default {
	'fiscal-account': 'Mali hesap',
	users: 'Kullanıcılar',

	'tax-percent': 'KDV yüzdesi',
	cashbox: 'Kasa',
	cashboxes: 'Kasalar',
	delete: 'Sil ',
	active: 'Aktif',
	inactive: 'Aktif değil',
}